import * as gfunctions from '../../../js/generalFunctions';

CCL.multipleSailingExtended = {
  autoload: [
    ['ageClick', $('.age-item').length > 0],
    ['sailingClick', $('.sailing-item').length > 0],
    ['modalEvents', $('#multipleSailingExtendedModal').length > 0]
  ],
  ageClick() {
    $('.age-item').click((e) => {
      $('#ageDropdownMenu')[0].innerText = e.currentTarget.innerText;
      $('.dropdown-menu button').removeClass('active');
      e.currentTarget.className += ' active'; // Append active class to selected
    });
  },
  sailingClick() {
    $('.sailing-item').click((e) => {
      console.dir(e.currentTarget.innerText);
      $('#sailingMenu')[0].innerText = e.currentTarget.innerText;
      $('.dropdown-menu button').removeClass('active');
      e.currentTarget.className += ' active'; // Append active class to selected
    });
  },
  modalEvents() {
    const modalEl = $('#multipleSailingExtendedModal');
    const firstFocusable = gfunctions.getFocusableElements(modalEl);
    const lastFocusable = gfunctions.getFocusableElements(modalEl, 'last');

    firstFocusable.on('keydown', (event) => {
      if ((event.keyCode === 9) && (event.shiftKey)) {
        event.preventDefault();
        lastFocusable.focus();
      }
    });
    lastFocusable.on('keydown', (event) => {
      if ((event.keyCode === 9) && !(event.shiftKey)) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-multiple-sailing-extended-modal/multiple-sailing-extended-modal.js